import React, { useLayoutEffect, useRef, useState } from "react";
import classnames from "classnames";

// Sub-pixel scroll positions still count as the edge
const EDGE_TOLERANCE = 1;

/**
 * One line of text that scrolls sideways when it doesn't fit; the side with
 * more text to scroll to fades out.
 */
export const ScrollText = ({ children }) => {
  const ref = useRef(null);
  const [fade, setFade] = useState({ start: false, end: false });

  const updateFade = () => {
    const el = ref.current;

    if (!el) return;

    setFade({
      start: el.scrollLeft > EDGE_TOLERANCE,
      end: el.scrollLeft + el.clientWidth < el.scrollWidth - EDGE_TOLERANCE,
    });
  };

  useLayoutEffect(() => {
    updateFade();
    window.addEventListener("resize", updateFade);

    return () => window.removeEventListener("resize", updateFade);
  }, [children]);

  // A mouse wheel only scrolls vertically, so it moves the text sideways here
  const handleWheel = (event) => {
    const el = ref.current;

    if (el.scrollWidth <= el.clientWidth) return;
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

    el.scrollLeft += event.deltaY;
  };

  return (
    <span
      ref={ref}
      className={classnames("trade-meta__scroll", {
        "trade-meta__scroll--fade-start": fade.start,
        "trade-meta__scroll--fade-end": fade.end,
      })}
      onScroll={updateFade}
      onWheel={handleWheel}
    >
      {children}
    </span>
  );
};
